'use client';

import { Helmet } from 'react-helmet';
/**
 * This component handles consent for users who land directly on the app,
 * complementing the URL parameter logic in public/index.html.
 */
const GoogleAnalytics = () => {
  return (
    <>
      <Helmet>
        <script>
          {`
            // This script runs after the one in index.html. It handles cases where
            // a user lands directly on the app and already has a consent cookie.
            const consentCookie = document.cookie.split('; ').find(row => row.startsWith('tubeTactixGDPRConsent='));
            if (consentCookie && consentCookie.split('=')[1] === 'true') {
              window.gtag('consent', 'update', { 'analytics_storage': 'granted' });
              // Send a pageview event if consent was already granted on page load
              dataLayer.push({
                event: 'page_view',
                page_path: window.location.pathname + window.location.search,
              });
            }
          `}
        </script>
      </Helmet>
    </>
  );
};

export default GoogleAnalytics;